var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductiveMind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 36,
    viewBox: "0 0 26 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0008 27.1223V18.8098M13.0008 18.8098C13.8019 18.8104 14.5999 18.7098 15.3758 18.5105M13.0008 18.8098C12.1997 18.8104 11.4017 18.7098 10.6258 18.5105M16.5633 30.3507C14.2093 30.7977 11.7923 30.7977 9.4383 30.3507M15.3758 34.1238C13.7968 34.2891 12.2048 34.2891 10.6258 34.1238M16.5633 27.1223V26.8183C16.5633 25.2619 17.6051 23.9319 18.951 23.1513C21.212 21.8419 22.978 19.8235 23.9755 17.4086C24.973 14.9937 25.1462 12.3173 24.4684 9.79402C23.7905 7.27072 22.2993 5.04143 20.226 3.45156C18.1526 1.86169 15.6128 1 13 1C10.3872 1 7.84741 1.86169 5.77405 3.45156C3.70068 5.04143 2.20953 7.27072 1.53165 9.79402C0.853765 12.3173 1.02699 14.9937 2.02448 17.4086C3.02197 19.8235 4.78804 21.8419 7.04905 23.1513C8.39488 23.9319 9.4383 25.2619 9.4383 26.8183V27.1223",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductiveMind);
export default __webpack_public_path__ + "static/media/productiveMind.8e7fdde5b13805fa8d8c97520798baad.svg";
export { ForwardRef as ReactComponent };